(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/winner-ticker/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/widgets/winner-ticker/assets/javascripts/constants.js');

'use strict';

let isProd;
if (svs.isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  isProd = trinidad.config.options.tpns === 'prod';
} else {
  var _svs$widgets;
  isProd = (_svs$widgets = svs.widgets) === null || _svs$widgets === void 0 || (_svs$widgets = _svs$widgets.winner_ticker) === null || _svs$widgets === void 0 || (_svs$widgets = _svs$widgets.data) === null || _svs$widgets === void 0 ? void 0 : _svs$widgets.isProd;
}
const TickerBrand = {
  BINGO: 'bingo',
  CASINO: 'casino',
  MOMANG: 'momang'
};
const TickerFeed = {
  BINGO: 'bingo',
  SLOTS: 'slots',
  LIVE_CASINO: 'livecasino'
};
const imagesPath = '/images/bingo/winner-ticker-images';
const BingoImgSrcProd = {
  6: "".concat(imagesPath, "/nojesparken.jpeg"),
  7: "".concat(imagesPath, "/fikapausen.jpeg"),
  8: "".concat(imagesPath, "/smorgasbordet.jpeg"),
  11: "".concat(imagesPath, "/chartern.jpeg"),
  12: "".concat(imagesPath, "/kronjuvelen.jpeg"),
  19: "".concat(imagesPath, "/kryssningen.jpeg"),
  20: "".concat(imagesPath, "/godisregnet.jpeg")
};
const BingoImgSrcTest = {
  8: "".concat(imagesPath, "/fikapausen.jpeg"),
  9: "".concat(imagesPath, "/smorgasbordet.jpeg"),
  11: "".concat(imagesPath, "/chartern.jpeg"),
  25: "".concat(imagesPath, "/kronjuvelen.jpeg"),
  43: "".concat(imagesPath, "/nojesparken.jpeg"),
  45: "".concat(imagesPath, "/godisregnet.jpeg"),
  47: "".concat(imagesPath, "/kryssningen.jpeg")
};
const toExport = {
  TickerBrand,
  TickerFeed,
  BingoImgSrc: isProd ? BingoImgSrcProd : BingoImgSrcTest
};
if (svs.isServer) {
  module.exports = toExport;
} else {
  setGlobal('svs.widget.winner_ticker.constants', toExport);
}

 })(window);